import { render, staticRenderFns } from "./VirtualTable.vue?vue&type=template&id=b5638074&scoped=true"
import script from "./VirtualTable.vue?vue&type=script&lang=js"
export * from "./VirtualTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualTable.vue?vue&type=style&index=0&id=b5638074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5638074",
  null
  
)

export default component.exports